import { cn } from '@shared/lib/utils';

interface DecimalUsdtInputProps {
  id?: string;
  value: string;
  /** Suffix and unit of the amount. Direct rules use the selected token, for example BNB. */
  assetCode?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
  'aria-label'?: string;
  'aria-describedby'?: string;
  onChange: (value: string) => void;
}

export const DecimalUsdtInput = ({
  id,
  value,
  assetCode = 'USDT',
  disabled = false,
  error,
  className,
  onChange,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
}: DecimalUsdtInputProps) => (
  <div className="w-full min-w-0">
    <div
      className={cn(
        'flex h-10 w-full min-w-0 items-center overflow-hidden rounded-lg border border-border bg-background',
        'shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] transition-colors',
        'focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-0',
        error && 'border-destructive focus-within:ring-destructive',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
    >
      <input
        id={id}
        inputMode="decimal"
        value={value}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        aria-invalid={error ? true : undefined}
        onChange={(event) => onChange(event.target.value)}
        className="min-w-0 flex-1 border-0 bg-transparent px-3 py-2 text-sm text-foreground tabular-nums placeholder:text-muted-foreground focus:outline-none disabled:cursor-not-allowed"
      />
      <span className="shrink-0 border-l border-border px-3 text-xs text-muted-foreground">{assetCode}</span>
    </div>
    {error && <p className="mt-1.5 text-xs text-destructive">{error}</p>}
  </div>
);
